import { RuntimeEnvironmentOptions, getEnvFromHostname } from '@growtherapy/analytics';

export function getSegmentConfig(): { segmentWriteKey: string } {
  const env = getEnvFromHostname({ hostname: window.location.hostname });
  switch (env) {
    case RuntimeEnvironmentOptions.production:
      return {
        segmentWriteKey: 'h4fMRkcCYrVqDzBGMzj7yRbXa0vYilHN',
      };
    case RuntimeEnvironmentOptions.staging:
      return {
        segmentWriteKey: 'SXuhdNATcYd1Hf2RMy4EFAQDkp05nx9g',
      };
    case RuntimeEnvironmentOptions.local:
      return {
        segmentWriteKey: 'oOsNlwHUnzTwyf1ZStjhsYeW0R2U8utZ',
      };
    default:
      return {
        segmentWriteKey: 'oOsNlwHUnzTwyf1ZStjhsYeW0R2U8utZ',
      };
  }
}
